const state = {
  list: {
    num: 0,
    agencies: []
  },
  agency: {},
  new: {}
}
export default state
